import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import Headroom from 'react-headroom'
import {Link} from 'react-router'
import NavLink from '../Component/NavLink'
import * as firebase from 'firebase'

const Jeyu = {
  Logo: {
    color: '#fff',
    fontSize: 30,
    padding: '10px 35px 0',
    display: 'block'
  },
  userPhoto: {
    width: 45,
    height: 45,
    overflow: 'hidden',
    borderRadius: 77,
    display: 'inline-block'
  }
}

export default class Header extends Component {
  constructor() {
    super()
    this.state = {
      email: '',
      displayName: '',
      photoURL: ''
    }
    this.Login = this.Login.bind(this)
    this.Logout = this.Logout.bind(this)
  }
   Login() {
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider).then((result) => {
    //  var token = result.credential.accessToken;
    //  var user = result.user;
     window.location = ('/UserProfile');
   }).catch((error) => {
    //  var errorCode = error.code;
    //  var errorMessage = error.message;
    //  var email = error.email;
    //  var credential = error.credential;
    });
   }
   Logout() {
     firebase.auth().signOut().then(() => {
       console.log('signOut')
     })
   }
  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
     const checkLogin = ReactDOM.findDOMNode(this.refs.checkLogin)
     if (user) {
      //  console.log(user) // 上線就要關閉
       var userId = firebase.auth().currentUser.uid
       firebase.database().ref('users/' + userId + '/UserProfile/').set({
         email: user.email,
         displayName: user.displayName,
         photoURL: user.photoURL
       });
       checkLogin.classList.add('isLogin')
       const rootRef = firebase.database().ref('users/').child(userId).child('UserProfile')
       rootRef.on('value', snap => {
         this.setState({
           email: snap.val().email,
           displayName: snap.val().displayName,
           photoURL: snap.val().photoURL
         })
       })
     } else {
       console.log('error')
       checkLogin.classList.remove('isLogin')
     }
    });
  }
  render() {
    return(
      <Headroom className="header">
       <div className="container">
        <div className="row">
         <div className="lg-2">
          <Link to="/" style={Jeyu.Logo}>JWorld</Link>
         </div>
         <div className="lg-10">
          <nav>
           <NavLink to="/Conversation">Home</NavLink>
           <a href="#" onClick={this.Login} ref="checkLogin" className="loginbox">login</a>
           <Link to="/UserProfile" className="logOutPhotobox"><img style={Jeyu.userPhoto} alt={this.state.photoURL} src={this.state.photoURL} /></Link>
           <Link to="/" onClick={this.Logout} className="logOutbox">logout</Link>
          </nav>
         </div>
        </div>
       </div>
      </Headroom>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Layout/Header.js